import { render, staticRenderFns } from "./ComponentWait.vue?vue&type=template&id=558a3e06&scoped=true"
import script from "./ComponentWait.vue?vue&type=script&lang=js"
export * from "./ComponentWait.vue?vue&type=script&lang=js"
import style0 from "./ComponentWait.vue?vue&type=style&index=0&id=558a3e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a3e06",
  null
  
)

export default component.exports